import { FC } from 'react'
import { Avatar } from '@/components/atoms/Avatar'
import { CloseButton } from '@/components/atoms/CloseButton'
import { IAnswerBase } from '@/types'
import { getUserAvatar, getDateTimeFromUtc } from '@/utils'
import styles from './index.module.scss'

type Props = {
  reply: IAnswerBase
  toggleModal: () => void
  isQuestioner: boolean
}

export const ReplyModalParentContent: FC<Props> = ({ reply, toggleModal, isQuestioner = false }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <div className={styles.respondentGroup}>
          <div className={styles.avatar}>
            <Avatar src={getUserAvatar(reply?.respondent)} alt={reply?.respondent.name} />
          </div>
          <div className={styles.name}>{reply?.respondent.name}</div>
        </div>
      </div>
      <div className={styles.lineContainer}>
        <div className={styles.line} />
        <div>
          <div className={styles.timeGroup}>
            {isQuestioner && <div className={styles.questioner}>Questioner</div>}
            <div className={styles.time}>{getDateTimeFromUtc(reply?.updatedAt, 'YYYY/M/D HH:mm')}</div>
          </div>
          <p className={styles.body}>{reply?.body}</p>
        </div>
      </div>
      <div className={styles.closeButton}>
        <CloseButton onClick={toggleModal} isLarge />
      </div>
    </div>
  )
}
